
/**
 * Utility functions specifically related to guards
 */

/**
 * Generates a guard password from AFM using the pattern: G + last 4 digits + #Secure123
 */
export const generateGuardPassword = (afm: string | undefined | null): string => {
  if (!afm) return 'G0000#Secure123';
  
  const cleanedAFM = afm.replace(/\D/g, '');
  const lastFourDigits = cleanedAFM.slice(-4).padStart(4, '0');
  return `G${lastFourDigits}#Secure123`;
};

/**
 * Ensures a password meets the minimum requirements
 * @deprecated Use generateGuardPassword instead for consistent password generation
 */
export const ensureValidPassword = (password: string): string => {
  if (!password || password.length < 6) {
    return `${password || ''}#Secure123`;
  }
  return password;
};

/**
 * Generates a guard code from an AFM (tax number)
 */
export const generateCodeFromAFM = (afm: string | undefined | null): string => {
  if (!afm) return 'G0000';
  
  const cleanedAFM = afm.replace(/\D/g, '');
  
  const lastFourDigits = cleanedAFM.slice(-4).padStart(4, '0');
  return `G${lastFourDigits}`;
};
